import * as type from 'constants/ActionTypes';

export const fetchLanguages = () => ({
  type: type.FETCH_LANGUAGES_REQUEST,
});

export const fetchLanguagesSuccess = languages => ({
  type: type.FETCH_LANGUAGES_SUCCESS,
  languages,
});

export const fetchLanguagesFailure = error => ({
  type: type.FETCH_LANGUAGES_FAILURE,
  error,
});
